import PropTypes from 'prop-types';

const example = PropTypes.shape({
  text: PropTypes.string,
  url: PropTypes.string,
  note: PropTypes.string,
  display_index: PropTypes.number,
});

export default {
  example,
  examples: PropTypes.arrayOf(example),
};
